function normalizeEditingPlanId(value) {
  const normalizedValue = String(value ?? "").trim().toLowerCase();
  return normalizedValue || null;
}

function findBrowserPlan(browserPlans = [], normalizedPlanId) {
  if (!normalizedPlanId) {
    return null;
  }

  return (Array.isArray(browserPlans) ? browserPlans : []).find(
    (plan) => normalizeEditingPlanId(plan?.id) === normalizedPlanId,
  ) ?? null;
}

export function shouldKeepOpenedClientNutritionPlanSelection({
  editingPlanId,
  planEntity,
  clientPlanStore,
} = {}) {
  const normalizedPlanId = normalizeEditingPlanId(editingPlanId);
  if (!normalizedPlanId || planEntity) {
    return false;
  }

  return clientPlanStore?.isPlanInWorkspaceTransition?.(normalizedPlanId) === true;
}

export function resolveOpenedClientNutritionPlan({
  editingPlanId,
  clientPlanStore,
  browserPlans = [],
} = {}) {
  const normalizedPlanId = normalizeEditingPlanId(editingPlanId);
  if (!normalizedPlanId) {
    return null;
  }

  const planEntity =
    clientPlanStore?.planEntitiesById?.get?.(normalizedPlanId) ?? null;
  const browserPlan = findBrowserPlan(browserPlans, normalizedPlanId);
  const rootRecord =
    clientPlanStore?.planRootRecordsById?.get?.(normalizedPlanId) ??
    browserPlan?.rootRecord ??
    browserPlan ??
    null;

  return {
    id: normalizedPlanId,
    planEntity,
    rootRecord,
    browserPlan,
  };
}

export function resolveOpenedClientNutritionPlanPersistedSource(openedPlan = null) {
  if (openedPlan?.planEntity) {
    return openedPlan.planEntity;
  }

  return openedPlan?.rootRecord ?? null;
}
